class VendorList extends HTMLElement {
  constructor() {
    super();

    this.populateLogos();
  }

  populateLogos() {
  	const $logos = this.querySelectorAll('.js-vendor');

	$logos.forEach($elm => {
		const src = $elm.getAttribute('data-image');
		const name = $elm.getAttribute('data-name');

		if( typeof src == "undefined" )
			return;

		let image = new Image();
		image.src = src;
		image.alt = name;

		image.onload = function() {
			$elm.classList.add('vendor-list__item--has-image');
			$elm.append(image);
		}
	});
  }
}

customElements.define('vendor-list', VendorList);